import { FETCH_FAILURE } from '../../../../middleware';
import { sessionExpired } from '../../../../session';
import { EffectOptions } from '../app-effects-middleware.types';
import { handleLogoutRedirect } from './logout.effects';
import {
    RESPONSE_ERROR_CODES, RESPONSE_STATUS_CODES
} from '@api';

const fetchFailureActionReg = new RegExp(FETCH_FAILURE);

/**
 * Handle failure response objects from any fetch api calls.
 * Most of this logic was handled in angular http-request-interceptor.js.
 */
export function fetchFailureEffects ({
    getState, action, dispatch
}: EffectOptions) {
    if (!fetchFailureActionReg.test(action.type)) {
        return;
    }
    console.debug('fetchFailureEffects', action?.payload);

    const code = action?.payload?.error?.code;

    /**
     * When the auth token is invalid or sends the ExpiredToken code,
     * update the redux application store to reflect this state.
     */
    if (
        code === RESPONSE_ERROR_CODES.ExpiredToken ||
        code === RESPONSE_ERROR_CODES.TamperedToken ||
        code === RESPONSE_ERROR_CODES.MissingToken
    ) {
        dispatch(sessionExpired());

        return;
    }

    const status = action?.payload?.error?.status;

    if (status === RESPONSE_STATUS_CODES.SESSION_EXPIRED) {
        handleLogoutRedirect({
            state: getState(),
            dispatch
        });

        return;
    } else if (status === RESPONSE_STATUS_CODES.NOT_FOUND) {
        console.error('404: no record found');

        return;
    }

    console.error('fetchFailureEffects unhandled fetch failure action', action);
}
